export default {
  name: 'culture-card',
  props: {
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    paragraph: {
      type: Array,
      required: true
    }
  }
};